<ion-header collapse="fade" class="ion-no-border" [ngClass]="{ 'bg-contrast': bgContrast() || (bgContrast$ | async) }">
  <ion-toolbar>
    <ng-content></ng-content>
  </ion-toolbar>

  <ng-content select="app-stepper-redesign"></ng-content>
</ion-header>
